import { Route, Redirect, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { ConfigProvider, Skeleton, Spin } from "antd";
import { IntlProvider } from "react-intl";
import { connect } from 'react-redux';
import AppLocale from "./languageProvider";
import PropTypes from "prop-types";

import App from './containers/App/index';
import Signin from './containers/User/Signin';
import { isExpirationLocalStorageValueConsideredValid } from './helpers/utility';

const RestrictedRoute = ({ component: Component, isLoggedIn, currentUser, ...rest }) => {
  let restrictedRoute = (<Route
    {...rest}
    render={(props) => isLoggedIn
      ? currentUser ? <Component {...props} /> : <Spin spinning={true}><Skeleton ></Skeleton></Spin>
      : <Redirect
        to={{
          pathname: '/signin',
          state: { from: props.location },
        }}
      />}
  />);
  return restrictedRoute;
}

const PublicRoutes = ({ history, language, languageMessages, currentUser }) => {
  const currentAppLocale = AppLocale[language.locale];
  const isLoggedIn = isExpirationLocalStorageValueConsideredValid();

  return (
    <ConfigProvider locale={currentAppLocale.antd}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={languageMessages}
        key={currentAppLocale.locale}
      >
        <ConnectedRouter history={history}>
          <Switch>
            <Route
              exact
              path={'/signin'}
              component={Signin}
            />

            <RestrictedRoute
              path="/Dashboard"
              component={App}
              isLoggedIn={isLoggedIn}
              currentUser={currentUser}
            />
            <RestrictedRoute
              path="/*"
              component={() => <Redirect to={'/Dashboard'} />}
              isLoggedIn={isLoggedIn}
              currentUser={currentUser}
            />

            <Route
              exact
              path={'/*'}
              component={() => <Redirect to={'/'} />}
            />
          </Switch>
        </ConnectedRouter>
      </IntlProvider>
    </ConfigProvider>
  );
};

PublicRoutes.propTypes = {
  currentUser:PropTypes.object,
  language:PropTypes.object.isRequired,
  languageMessages:PropTypes.any,
  history:PropTypes.any.isRequired
};

export default connect(state => ({
  language: state.LanguageSwitcher.toJS().language,
  languageMessages: state.LanguageSwitcher.toJS().languageMessages,
  currentUser: state.Auth.get('currentUser'),
}))(PublicRoutes);
